module.exports = __webpack_public_path__ + "media/images/pic/godzilla-33d206f95952bbdc28545e84351b2093.svg";